import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { SnackbarProvider } from 'notistack'
import { HashRouter as Router, Switch } from 'react-router-dom'
import { hot } from 'react-hot-loader'
import Home from 'pages/Home'
import Login from 'pages/Login'
import Admin from 'pages/Admin'
import Install from 'pages/Install'
import WebclapRoute from 'utils/WebclapRoute'

const useStyles = makeStyles({
	success: { background: 'linear-gradient(135deg, #70F570 10%, #49C628 100%)' },
	error: { background: 'linear-gradient(135deg, #F05F57 10%, #E80505 100%)' },
	warning: { background: 'linear-gradient(135deg, #FDD819 10%, #FA742B 100%)' },
	info: { background: 'linear-gradient(135deg, #43CBFF 10%, #130CB7 100%)' },
})

function App() {
	const classes = useStyles()

	useEffect(() => {
		document.title = '웹박수'
	}, [])

	return (
		<SnackbarProvider
			maxSnack={3}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			classes={{
				variantSuccess: classes.success,
				variantError: classes.error,
				variantWarning: classes.warning,
				variantInfo: classes.info,
			}}
			autoHideDuration={3000}
		>
			<Router>
				<Switch>
					<WebclapRoute path="/" exact component={Home} />
					<WebclapRoute type="login" path="/login" component={Login} />
					<WebclapRoute type="private" path="/admin" component={Admin} />
					<WebclapRoute type="install" path="/install" component={Install} />
				</Switch>
			</Router>
		</SnackbarProvider>
	)
}

export default hot(module)(App)
